import React from 'react';
import { attemptSocialLogin as attemptSocialLoginAction } from '../redux/actions';
import { SocialLoginProvider } from '../types';
import SocialButtonBase from '../SocialButtonBase';

export interface Props {
  className?: string;
  redirectToJoin?: boolean;
  attemptSocialLogin: typeof attemptSocialLoginAction;
}

const SocialButtonTest: React.FC<Props> = ({
  className,
  redirectToJoin = false,
  attemptSocialLogin,
}) => {
  return (
    <SocialButtonBase
      className={className}
      onClick={e => {
        e.preventDefault();
        attemptSocialLogin({
          provider: SocialLoginProvider.Test,
          token: `123-${Math.random()}`,
          redirectToJoin,
        });
      }}
    >
      Test social button
    </SocialButtonBase>
  );
};
SocialButtonTest.displayName = 'SocialButtonTest';

export default SocialButtonTest;
